import { render, staticRenderFns } from "./ImportProcessFinishedNotification.vue?vue&type=template&id=fb73434e&scoped=true&"
import script from "./ImportProcessFinishedNotification.vue?vue&type=script&lang=js&"
export * from "./ImportProcessFinishedNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb73434e",
  null
  
)

export default component.exports